import { useEffect } from "react";
import { PageControl, KIND } from "baseui/page-control";
import { useNavigate } from 'react-router-dom';
import { Analytics,Gtag } from '../../compornents/Analytics';
import React from 'react';
import { BAG_FIRST } from '../../bagFirst';

// サービスの流れ STEP.1/4（bag-first改定 2026-09-01）。
// 改定前は「バッグを依頼→受け取る」の2枚だったが、新動線では
// 「バッグが届く → 入れる → 自分で集荷を依頼する → 届く」の4工程になる。
// 特にSTEP.1で「最初の配達はバッグであって、依頼品はまだ渡せない」ことを
// 注文前から刷り込んでおくのが、この改定で最も重要な役割。
export const RegisterStep1 = () => {
  const navigate = useNavigate();

  const next = () => {
    navigate('/register/step2');
  }

  useEffect(() => {
    Gtag('view_register_step1');
  }, []);

  return (
    <div>
      <div>
        <Analytics title="Step1" />
        <div className="Register">
          <div className="App-step1">
            <div className="App-h1 pt-4">{"STEP.1"}</div>
            <img src="/img/step1.png" alt={BAG_FIRST ? "専用バッグのお届け" : "step1"} className="App-img" />
            {BAG_FIRST ? (
              <>
                <div className="App-title-sm">まず専用バッグを<br /><span className="text-danger">無料</span>でお届け</div>
                <div className="App-comment">{"ご注文いただくと、最初に衣類専用バッグを無料でお届けします。"}</div>
                {/* 改定で最も重要な一文。最初の配達はバッグであって依頼品は渡せない、を注文前に刷り込む */}
                <div className="step-warn">※このときはまだ<br />衣類をお渡しいただけません</div>
              </>
            ) : (
              <>
                <div className="App-title-sm"><span className="text-danger">初回無料</span>の専用バッグを<br/>依頼する</div>
                <div className="App-comment">{"スマホからUber Eatsの配達パートナーに伝える住所を入力する"}</div>
              </>
            )}
            <div className="App-h3">
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '20px',
                }}
              >
                <PageControl
                  currentPage={1}
                  numPages={BAG_FIRST ? 4 : 2}
                  kind={KIND.default}
                  aria-label="label"
                />
              </div>
              <button className="button-next-w" onClick={next}>{"次へ"}</button>
              <div><img src="../img/Direct_delivered with_Uber Eats_horiz_pill_green_en_1@2x.png" className="ud_img" alt="ud logo" /></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
